import React, { useContext, useState, useCallback, useEffect, useMemo } from 'react'
import styled, { ThemeContext } from 'styled-components'
import { RouteComponentProps } from 'react-router-dom'

// components
import Loading from '../../components/Loader/Loading'
import {
  TextLabel,
  BidTrad,
  TabRow,
} from '../../components/nftInfo/InfoStyle'
import NoArtworks from '../../components/nftInfo/NoArtworks'
// import Artworks from '../../components/nftInfo/Artworks'
import ArtworkCard from '../../components/Collection/ArtworkCard'
import Paginator from '../../components/Paginator'
import BiddingList from '../../components/nftInfo/BiddingList'
import TradingList from '../../components/nftInfo/TradingList'
import InfoAddress from '../../components/nftInfo/InfoAddress'
import Introduction from '../../components/nftInfo/Introduction'
import InfoButton from '../../components/nftInfo/InfoButton'
import InfoImgCard from '../../components/nftInfo/InfoImgCard'
import Row, { RowColumn } from '../../components/Row'
import CryptoSolt from './components/CryptoSolt'
import BarkingSolt from './components/BarkingSolt'
import PokerSolt from './components/PokerSolt'
import RareSolt from './components/RareSolt'
import EquipmentSolt from './components/EquipmentSolt'
import PetSolt from './components/PetSolt'
import WeaponSolt from './components/WeaponSolt'
import EggSolt from './components/EggSolt'
import ComboSolt from './components/ComboSolt'

import { userNftSupportToken } from '../../userType/userNftSupportToken'

import { getBidRacaNFTAddress } from '../../sushi/utils'
import { BigNumber } from '../../sushi'

// utils
import { PetSortOption, WeaponSortOption, ComboSortOption, SortOptions, TabOptions, AuctionBake, defaultArtworks } from '../../constants/artwork'
import { MARKETTYPEV1, MARKETTYPE, MARKETTYPEV3, SUPPORTTYPE, MARKETMULTITOKEN } from '../../constants/bakery/nft'
import { petMap, supportPetType, PetType } from '../../constants/pet'

import { deepCopy } from '../../utils/func'

// hooks
import { useActiveWeb3React } from '../../hooks'
import useYam from '../../hooks/bakery/useYam'
import useInterval from '../../hooks/useInterval'
import { useReviewAddress } from '../../hooks/launchArtworks/useContract'
import { userMarketType } from '../../userType/userMarketType'
import { userNFTType } from '../../userType/userNFTType'
import useParsedQueryString from '../../hooks/useParsedQueryString'
import useBakerySoccerRoi from '../../hooks/nft/useBakerySoccerRoi'
import useBlock from '../../hooks/bakery/useBlock'
import useBlockNum from '../../hooks/bakery/useBlockNum'
import { useWeaponNftContract } from '../../hooks/pets/useContract'
import { getWeaponInfo } from '../../sushi/utils'

import SortPets from '../Pet/components/SortPets'

import { getArtworks, getArtworksV2, getArtworksV3, getGameInfo, getGameList } from '../../service/nft'
import DEFAULT_LIST from '../../constants/token/bakeryswap.json'

import {
  useDoggyBalance,
  useBarkBalance,
  useRacaBalance,
  useBusdBalance,
  useDogeBalance,
  useBakeBalance,
  useTokauBalance,
  useSfpBalance
} from '../../hooks/useAllTokenBalance'

export const RowInfo = styled(Row)<{width?: string}>`
  width: 1134px;
  flex-direction: column;
  ${({ theme }) => theme.mediaWidth.upToInfoLarge`
    width: 100%;
    padding: 0 10px;
  `}
`
export const InfoDetail = styled(Row)`
  padding: 0 0 16px;
  align-items: flex-start;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    flex-direction: column;
    align-items: center;
  `}
`
export const InfoRight = styled(RowColumn)<{margin?: string}>`
  margin-left: 24px;
  width: 610px;
  align-items: flex-start;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    margin-left: 0;
    width: 100%;
    align-items: center;
  `}
`
const ArtworkList = styled.div`
  margin-bottom: 20px;
  width: 100%;
  display: grid;
  justify-content: space-between;
  grid-template-columns: repeat(auto-fill, 272px);
  ${({ theme }) => theme.mediaWidth.upToSmall`
    justify-content: center;
  `}
`

const otherType = {
  'weapon': 'weapons',
  'petEgg': 'pets',
  'pet': 'pets/nfts',
  'combo': 'combos'
}

export default function ArtworkInfo ({
  match: {
    params: { tokenId, isMyArtwork, price, status }
  },
  history
}: RouteComponentProps<{ tokenId: string, isMyArtwork: string, price: string, status: string }>) {
  const query:any = useParsedQueryString()
  const yam = useYam()
  let level = (query.level && query.level !== 'undefined') ? query.level : 'v2'
  const NFTTYPE = userMarketType(query.type, level)
  const theme = useContext(ThemeContext)
  const [updateNum, setUpdateNum] = useState(1)
  const { account, chainId } = useActiveWeb3React()
  const [loadingFlag, setLoadingFlag] = useState(false)
  const [artwork, setArtwork] = useState({...deepCopy(defaultArtworks), tokenId: tokenId, price: price, nftType: query.type})

  const reviewAddress: any = useReviewAddress()
  const [canReview, setCanReview] = useState((account && reviewAddress ? reviewAddress.includes(account) : false))
  useEffect(() => {
    if (account && reviewAddress) {
      setCanReview(reviewAddress.includes(account))
    }
  }, [account, chainId, reviewAddress])

  const fetchArtworkInfo = async (tokenId: string, loading?: boolean) => {
    if (loading) {
      setLoadingFlag(true)
    }
    let params = {
      nftType: query.type,
      ids: `${query.type}-${tokenId}`
    }
    fetchAsksSort(params, true)
  }

  // // 根据tokenId获取详情
  // useEffect(() => {
  //   fetchArtworkInfo(tokenId, true)
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [tokenId, chainId])

  // 根据tokenId获取详情
  useEffect(() => {
    fetchArtworkInfo(tokenId, true)
    let dom = document.getElementById('BodyContainer')
    if(dom){
      dom.scrollTop = 0;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tokenId, chainId])

  // 获取列表
  const filterSortOption = useMemo(() => {
    if (['pet', 'petEgg'].includes(query.type)) {
      return PetSortOption
    } else if (['weapon'].includes(query.type)) {
      return WeaponSortOption
    } else if (['combo'].includes(query.type)) {
      return ComboSortOption
    } else {
      return SortOptions.filter((d) => d.name !== 'Power')
    }
  }, [SortOptions, query.type])

  const [curSelect, setCurSelect] = useState(filterSortOption[0])
  const [curTab, setCurTab] = useState(TabOptions[0])
  const emptyArtworks: any[] = []
  const [artworks, setArtworks] = useState(emptyArtworks)

  const [page, setPage] = useState(1)
  useEffect(() => {
    setPage(1)
  }, [account, chainId, level])
  
  const LIMIT = 4

  const fetchAsks = async (page: number, loading?: boolean) => {
    if (loading) {
      setLoadingFlag(true)
    }
    let params = {}
    if (query.type && ['weapon', 'pet', 'petEgg', 'combo'].includes(query.type)) {
      params = {
        others: {
          nftTypes: query.type,
          fileType: curTab.sortName,
          offset: (page - 1) * LIMIT,
          limit: LIMIT + 1,
          sortName: curSelect.sortName,
          sortBy: curSelect.sortBy,
          onSale: +status === 1 ? 1 : undefined,
          status: canReview ? status : 1
        }
      }
    } else {
      params = {
        nftType: query.type,
        fileType: curTab.sortName,
        offset: (page - 1) * LIMIT,
        limit: LIMIT + 1,
        sortName: curSelect.sortName,
        sortBy: curSelect.sortBy,
        onSale: +status === 1 ? 1 : undefined,
        status: canReview ? status : 1
      }
    }
    fetchAsksSort(params)
  }

  // 计算apy
  const currentBlock = useBlock()
  const blockNum = useBlockNum(currentBlock)
  let roi: any = 0
  if (['104', '108', '114'].includes(query.type)) {
    roi = useBakerySoccerRoi(blockNum as BigNumber, userNFTType(query.type))
  }
  
  // balance
  const bakeBalance = useBakeBalance()
  const doggyBalance = useDoggyBalance()
  const barkBalance = useBarkBalance()
  const racaBalance = useRacaBalance()
  const busdBalance = useBusdBalance()
  const dogeBalance = useDogeBalance()
  const tokauBalance = useTokauBalance()
  const sfpBalance = useSfpBalance()

  const weaponNft = useWeaponNftContract()
  // count
  const [pageCount, setPageCount] = useState(0)
  const fetchAsksSort = async (params: any, isInfo?: boolean) => {
    if (+params.fileType === 0) {
      (params.fileType as (string | number)) = ''
    }
    let getData
    if (level === 'v1') {
      getData = getArtworks
    } else if (level === 'v2') {
      getData = getArtworksV2
    } else {
      getData = getArtworksV3
    }
    if (query.type && ['weapon', 'pet', 'petEgg', 'combo'].includes(query.type)) {
      params['url'] = '/' + level + '/' + otherType[query.type]
      if (isInfo) {
        params['ids'] = tokenId
        getData = getGameInfo
      } else {
        getData = getGameList
      }
    }
    getData(chainId as number, params, async(err: any, data: any) => {
      if (err) return
      if (data.code !== 0) return
      const dataAry = data.data.list || []
      let allTokens = DEFAULT_LIST.tokens
      const artworks = await Promise.all(
        dataAry.map(async (d: any) => {
          let curLevel = (((d.auctionPrice && Number(d.auctionPrice)) && (d.price && Number(d.price) && +d.price === AuctionBake))
          || (d.price && Number(d.price))
          || ((d.auctionPrice && Number(d.auctionPrice)) && !Number(d.price) && (d.owner !== account))) ? level : 'v3'
          
          let curType = userMarketType(query.type, curLevel)
          let curMarketType = curType
          
          if (+query.type === 107 && curLevel === 'v2') {
            if(d.price) {
              if(d.exchangeAddress){
                if(d.exchangeAddress && d.exchangeAddress.toLowerCase() === getBidRacaNFTAddress(yam).toLowerCase()){
                  curMarketType = curType
                }else{
                  curMarketType = MARKETMULTITOKEN.RACAMULTITOKEN
                }
              }else{
                curMarketType = curType
              }
            } else{
              curMarketType = MARKETMULTITOKEN.RACAMULTITOKEN
            }
          }
          let tokenName: string = userNftSupportToken(+query.type)
          for(let i = 0;i < allTokens.length;i++){
            if(d.quoteToken && d.quoteToken.toLowerCase() === allTokens[i].address.toLowerCase()){
              tokenName = allTokens[i].symbol.toUpperCase()
            }
          }
          let tokenBalance = 0
          switch (tokenName) {
            case SUPPORTTYPE.BAKE:
              tokenBalance = bakeBalance
              break
            case SUPPORTTYPE.DOGGY:
              tokenBalance = doggyBalance
              break
            case SUPPORTTYPE.BARK:
              tokenBalance = barkBalance
              break
            case SUPPORTTYPE.RACA:
              tokenBalance = racaBalance
              break
            case SUPPORTTYPE.BUSD:
              tokenBalance = busdBalance
              break
            case SUPPORTTYPE.DOGE:
              tokenBalance = dogeBalance
              break
            case SUPPORTTYPE.TOKAU:
              tokenBalance = tokauBalance
              break
            case SUPPORTTYPE.SFP:
              tokenBalance = sfpBalance
              break
          }

          // Battle Pets
          let weapon: any = undefined
          if (isInfo && [MARKETTYPEV1.PETNFTV1, MARKETTYPE.PETNFT, MARKETTYPEV3.PETNFTV3].includes(curMarketType)) {
            weapon = d.weapon && weaponNft ? await getWeaponInfo(weaponNft, d.weapon) : undefined
          }

          // console.log('----', curLevel)
          return {
            ...d,
            roi: roi,
            nftLevel: curLevel,
            nftType: d.nftType || query.type,
            tokenName: tokenName,
            tokenBalance: tokenBalance,
            marketType: curMarketType,
            tokenId: d.nftId || d.id,
            name: ['weapon'].includes(query.type) ? ('lv' + (d.nftId || d.id)) : ['petEgg'].includes(query.type) ? (d.petType && supportPetType.includes(d.petType) ? petMap.name[d.petType] : petMap.name[PetType.kitten]) : d.name,
            status: d.hasOwnProperty('status') ? d.status : 1,
            maxBidPrice: (d.maxBidPrice && !Number(d.maxBidPrice)) && (d.auctionPrice && Number(d.auctionPrice)) ? d.auctionPrice.toString() : d.maxBidPrice,
            ...((d.price && Number(d.price)) ? {price: d.price.toString()} : {price: ''}),
            ...((d.auctionPrice && Number(d.auctionPrice)) && (d.price && Number(d.price) && +d.price === AuctionBake) ? {auctionPrice: d.auctionPrice.toString()} : {auctionPrice: ''}),
            ...(d.petToGet ? {petToGet: new BigNumber(d.petToGet).integerValue(BigNumber.ROUND_FLOOR).toNumber() + (weapon ? new BigNumber(+weapon.petToGet).div(new BigNumber(10).pow(18)).toNumber() : 0)} : {}),
            ...(d.bakeToGet ? {bakeToGet: new BigNumber(d.bakeToGet).integerValue(BigNumber.ROUND_FLOOR).toNumber() + (weapon ? new BigNumber(+weapon.bakeToGet).div(new BigNumber(10).pow(18)).toNumber() : 0)} : {}),
            ...(d.battlePower ? {battlePower: new BigNumber(d.battlePower.toString()).integerValue(BigNumber.ROUND_FLOOR).toNumber()} : {}),
            ...(d.stakingPower ? {stakingPower: new BigNumber(d.stakingPower.toString()).integerValue(BigNumber.ROUND_FLOOR).toNumber()} : {}),
            ...(d.stakingPowerAmount ? {stakingPowerAmount: d.stakingPowerAmount.toString()} : {}),
            ...(d.bakeAmount ? {bakeAmount: d.bakeAmount.toString()} : {})
          }
        })
      )
      if (isInfo) {
        if (artworks.length) {
          setArtwork(artworks[0])
        } else {
          setArtwork({...deepCopy(defaultArtworks), tokenId: tokenId, price: price, nftType: query.type})
        }
      } else {
        setPageCount(Math.ceil(data.data.count / LIMIT))
        setArtworks(artworks)
      }
      setLoadingFlag(false)
    })
  }

  const updateData = useCallback((d) => {
    setCurSelect(d)
    setPage(1)
  }, [])

  const upTab = useCallback((d) => {
    setCurTab(d)
    setPage(1)
  }, [])

  useEffect(() => {
    fetchAsks(page, true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [canReview, page, curSelect, chainId, curTab, level])

  useInterval(() => {
    fetchArtworkInfo(tokenId)
    // fetchAsks(page)
  }, account ? 10000 : null)

  const pageHandle = useCallback((value) => {
    setPage(value)
  }, [])

  const getApySolt = (value: any) => {
    if ([MARKETTYPE.DOGGYNFT, MARKETTYPEV3.DOGGYNFTV3].includes(value.marketType)) {
      return <CryptoSolt artwork={value} />
    }
    if ([MARKETTYPEV1.BARKNFTV1, MARKETTYPE.BARKNFT, MARKETTYPEV3.BARKNFTV3].includes(value.marketType)) {
      return <BarkingSolt artwork={value} />
    }
    if ([MARKETMULTITOKEN.EQUIPMENTMULTITOKEN, MARKETTYPEV3.EQUIPMENTV3].includes(value.marketType)) {
      return <EquipmentSolt artwork={value} />
    }
    if ([MARKETTYPE.POKERCARD, MARKETTYPEV3.POKERCARDV3].includes(value.marketType)) {
      return <PokerSolt artwork={value} />
    }
    if ([MARKETTYPE.CARNFT, MARKETTYPEV3.CARNFTV3].includes(value.marketType)) {
      return <RareSolt artwork={value} type="CAR_V3" />
    }
    if ([MARKETTYPEV1.DISHV1, MARKETTYPE.DISH, MARKETTYPEV3.DISHV3].includes(value.marketType)) {
      return <ComboSolt artwork={value} />
    }
    if ([MARKETTYPEV1.PETNFTV1, MARKETTYPE.PETNFT, MARKETTYPEV3.PETNFTV3].includes(value.marketType)) {
      return <PetSolt artwork={value} />
    }
    if ([MARKETTYPEV1.WEAPONNFTV1, MARKETTYPE.WEAPONNFT, MARKETTYPEV3.WEAPONNFTV3].includes(value.marketType)) {
      return <WeaponSolt artwork={value} />
    }
    if ([MARKETTYPEV1.EGGNFTV1, MARKETTYPE.EGGNFT, MARKETTYPEV3.EGGNFTV3].includes(value.marketType)) {
      return <EggSolt artwork={value} />
    }
    return null
  }

  return (
    <>
      <Loading open={loadingFlag} />
      <RowInfo>
        <InfoDetail>
          <InfoImgCard
            history={history}
            artwork={artwork}
            type={artwork.marketType}
            bakeBalance={artwork.tokenBalance}
            status={+status}
            canReview={canReview}
            isMyArtwork={+isMyArtwork === 1 ? true : false}
            tokenName={artwork.tokenName}></InfoImgCard>
          <InfoRight>
            <Introduction
              artwork={artwork}
              tokenName={artwork.tokenName}
              soltButton={
                <InfoButton
                  artwork={artwork}
                  type={artwork.marketType}
                  status={+status}
                  canReview={canReview}
                  updateNum={updateNum}
                  setUpdateNum={setUpdateNum}
                  isMyArtwork={+isMyArtwork === 1 ? true : false}
                  tokenName={artwork.tokenName}
                ></InfoButton>
              }
              soltApy={getApySolt(artwork)}
              soltAddress={<InfoAddress artwork={artwork} type={NFTTYPE} />} />
          </InfoRight>
        </InfoDetail>
        <BidTrad>
          <BiddingList updateNum={updateNum} type={NFTTYPE} tokenId={artwork.tokenId} tokenName={artwork.tokenName} />
          <TradingList updateNum={updateNum} type={NFTTYPE} nftId={artwork.tokenId} tokenName={artwork.tokenName} level={level} />
        </BidTrad>
          <TabRow margin="49px auto 36px" width="calc(100% - 40px)">
            <TextLabel style={{flex: 1}} height={37} color={theme.bsText36} size={24}>More Artworks</TextLabel>
            <TabRow>
              <SortPets
                bg={theme.bsBg30}
                wd='110px'
                margin="0 15px 0 0"
                curSelect={curTab}
                options={TabOptions}
                updateData={upTab}
              ></SortPets>
              <SortPets
                bg={theme.bsBg30}
                curSelect={curSelect}
                options={filterSortOption}
                updateData={updateData}
              ></SortPets>
            </TabRow>
          </TabRow>
          {
            artworks.length ? (
              <>
                <ArtworkList>
                  {
                    artworks.map((d, index) => {
                      return (
                        index < LIMIT ? <ArtworkCard key={d.id} artwork={d}></ArtworkCard> : ''
                      )
                    })
                  }
                </ArtworkList>
                {
                  pageCount > 1 && (
                    <Paginator pageCount={pageCount} curPage={page} page={pageHandle}></Paginator>
                  )
                }
              </>
            ) : !loadingFlag && <NoArtworks type={NFTTYPE} status={+status} />
          }
      </RowInfo>
    </>
  )
}
